const getStringParams = (params) => {
    const { filters, sort, limit, page = null, fields, query } = params

    let stringParams = []
    let filtersArray = []

    if (filters) {

        filters.map(filter=>{
            if(Array.isArray(filter)){
                filtersArray.push(filter.map(item=>{
                    return  `${item.field};${item.condition};${item.value}`
                }).join('||'))
            } else {
                filtersArray.push(`${filter.field};${filter.condition};${filter.value}`)
            }
        })
    }

    if (filters) stringParams.push(`filters=${filtersArray.join(',')}`)
    if (sort) stringParams.push(`sort=${sort}`)
    if (query) stringParams.push(`query=${query}`)
    if (limit) stringParams.push(`limit=${limit}`)
    if (page || page === 0) stringParams.push(`page=${page}`)
    if (fields) stringParams.push(`fields=${fields.join(';')}`)

    return stringParams.join('&')
}

export default getStringParams